import React from 'react';
import { AccountApprovedContainer } from '../../../containers';

export const AccountApproved = () => <AccountApprovedContainer />;
